import { useEffect, useState } from 'react';
import rentalsService from '../../services/rentals.service';
export const useBillingUnits = (canManage) => {
  const [state, setState] = useState({ rentals: [], rentalsLoading: canManage, unitsError: null });
  useEffect(() => {
    let current = true;
    if (!canManage) { setState({ rentals: [], rentalsLoading: false, unitsError: null }); return undefined; }
    setState({ rentals: [], rentalsLoading: true, unitsError: null });
    rentalsService.getBillingUnits().then(({ data }) => {
      if (current) setState({ rentals: data || [], rentalsLoading: false, unitsError: null });
    }).catch(() => { if (current) setState({ rentals: [], rentalsLoading: false, unitsError: 'Unable to load billing units. Please reload before starting a subscription.' }); });
    return () => { current = false; };
  }, [canManage]);
  return state;
};
